module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('b-card', {
    staticClass: " panel21"
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3",
      "fill": "",
      "align": "center",
      "active-nav-item-class": "font-weight-bold"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('monitoring.cashflow.title'),
      "lazy": ""
    }
  }, [_c('CashStats')], 1), _vm._v(" "), (!_vm.demo) ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('monitoring.mp.title'),
      "lazy": ""
    }
  }, [_c('MPstats')], 1) : _vm._e()], 1)], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cf8cdf9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf8cdf9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/StatisticsPage.vue
// module id = 2446
// module chunks = 2